import React from "react";
import { RiStockLine, RiLineChartLine, RiFundsFill } from "react-icons/ri";
import { HiArrowTrendingUp, HiShieldCheck } from "react-icons/hi2";
import "../styles/Pages.css";

const InvestSavePage = ({ user }) => {
  const investmentOptions = [
    {
      id: "stocks",
      icon: <RiStockLine />,
      title: "Stock Portfolio",
      description: "Build wealth with equity investments",
      performance: "+18.5% YTD",
      risk: "Medium-High",
      minInvestment: "R1,000",
    },
    {
      id: "bonds",
      icon: <RiLineChartLine />,
      title: "Government Bonds",
      description: "Secure fixed-income investments",
      performance: "+6.2% p.a.",
      risk: "Low",
      minInvestment: "R10,000",
    },
    {
      id: "mutual",
      icon: <RiFundsFill />,
      title: "Mutual Funds",
      description: "Diversified managed portfolios",
      performance: "+12.8% YTD",
      risk: "Medium",
      minInvestment: "R500",
    },
    {
      id: "etf",
      icon: <HiArrowTrendingUp />,
      title: "ETF Trading",
      description: "Low-cost index fund investments",
      performance: "+15.3% YTD",
      risk: "Medium",
      minInvestment: "R100",
    },
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Invest & Save</h1>
        <p className="page-subtitle">
          Grow your wealth with smart investment strategies
        </p>
      </div>

      <div className="investment-products">
        <h3>Investment Products</h3>
        <div className="products-grid">
          {investmentOptions.map((option) => (
            <div key={option.id} className="product-card">
              <div className="product-icon">{option.icon}</div>
              <h4>{option.title}</h4>
              <p>{option.description}</p>
              <div className="product-details">
                <div className="detail-row">
                  <span className="detail-label">Performance:</span>
                  <span className="detail-value positive">
                    {option.performance}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Risk Level:</span>
                  <span className="detail-value">{option.risk}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Min. Investment:</span>
                  <span className="detail-value">{option.minInvestment}</span>
                </div>
              </div>
              <button className="btn-primary">Start Investing</button>
            </div>
          ))}
        </div>
      </div>

      <div className="investment-info">
        <div className="info-banner">
          <HiShieldCheck className="info-icon" />
          <div className="info-content">
            <h4>Your investments are protected</h4>
            <p>
              All investments are covered by the Financial Services Compensation
              Scheme
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestSavePage;
